export type ItemIconType =
  | "weapon"
  | "armor"
  | "tool"
  | "ammo"
  | "jewelry"
  | "container"
  | "consumable"
  | "resource"
  | "gem"
  | "bait"
  | "spell-scroll"
  | "currency"
  | string;

import { ICONS } from "./icons";

export function itemIconForType(type: ItemIconType | null | undefined): string {
  if (!type) return ICONS.itemsByType.unknown;
  return ICONS.itemsByType[String(type) as keyof typeof ICONS.itemsByType] || ICONS.itemsByType.unknown;
}
